import { FieldSet, IDataTableColumn, useGridState, useSearchApi } from "nsitools-react";
import * as React from "react";

import { ClubWorkbookRequestApi, ClubWorkbookRequestGridDto, ClubWorkbookRequestSearch } from "../../../../api";
import { CustomDataTable, ExportButton } from "../../../../components";
import { useGlobalData } from "../../../../contexts";
import { useApiService, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";
import { Link } from "react-router-dom";
import { getRouteStr } from "../../../../utils/RequestRouteUtil";

export interface IClubWorkbookRequestListProps {
  clubId: number;
}

export const ClubWorkbookRequestList: React.FunctionComponent<IClubWorkbookRequestListProps> = ({ clubId }) => {
  const api = useApiService(ClubWorkbookRequestApi);
  const { t } = useTl();
  const { currentLanguage } = useGlobalData();
  const [sObjState, setsobjState] = React.useState<any>();

  const tableState = useGridState<any>({
    serverMode: true,
    enablePagination: true,
    enableFilter: true,
    availablePageSizes: [15, 25, 50],
    pageSize: 15,
    sortKeys: { requestDate: "DESC" },
  });

  const searchFunction = React.useCallback(
    (sObj?: ClubWorkbookRequestSearch) => {
      setsobjState(
        ClubWorkbookRequestSearch.fromJS({ ...sObj, languageId: currentLanguage.languageId, clubId: clubId })
      );
      return api.baseSearch(
        ClubWorkbookRequestSearch.fromJS({ ...sObj, languageId: currentLanguage.languageId, clubId: clubId })
      );
    },
    [api, clubId, currentLanguage.languageId]
  );

  const { search, loading } = useSearchApi<any, any>({
    searchFunction,
    tableState,
    initialSearch: true,
    trimSearchObjectStringValues: true,
  });

  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        header: () => t(ETLCodes.RequestNumber),
        fieldName: "requestNumber",
        render: (row: ClubWorkbookRequestGridDto) => {
          return (
            <Link target="_blank" to={getRouteStr(row.requestTypeCode, row.subRequestId, "edit")}>
              {row.requestNumber}
            </Link>
          );
        },
      },
      {
        header: () => t(ETLCodes.RequestDate),
        fieldName: "requestDate",
      },
    ],
    [t]
  );

  React.useEffect(() => {
    search();
  }, [currentLanguage, search]);
  return (
    <FieldSet
      title={t(ETLCodes.Workbooks)}
      rightElement={<ExportButton exportFunction={(sObj) => api.exportXlsFile(sObj)} sObj={sObjState} />}
    >
      <CustomDataTable tableState={tableState} loading={loading} columns={columns} />
    </FieldSet>
  );
};
